<template>
  <v-tooltip :text="data.name" location="top" :disabled="!minimize">
    <template v-slot:activator="{ props }">
      <div
        v-bind="props"
        class="rounded-md flex gap-3 items-center relative cursor-pointer transition-all duration-300"
        :class="{
          'bg-red-100 border-[2px] border-red-700': active || isHovered,
          'hover:bg-red-100 border-[2px] hover:border-[2px] hover:border-red-700':
            !active,
          'p-3 w-56 justify-start': !minimize,
          'p-2 w-11 justify-center': minimize,
        }"
        @mouseenter="isHovered = true"
        @mouseleave="isHovered = false"
        @click="clickActive(data.id)"
      >
        <div
          class="w-8 h-8 rounded-lg flex justify-center items-center transition-all"
          :class="{
            'bg-red-700': active || isHovered,
            'bg-red-100': !active && !isHovered && data.id === 1,
            'bg-green-100': !active && !isHovered && data.id === 2,
            'bg-yellow-100': !active && !isHovered && data.id === 3,
            'bg-blue-100': !active && !isHovered && data.id === 4,
            'bg-orange-100': !active && !isHovered && data.id === 5,
          }"
        >
          <img
            :src="
              active || isHovered
                ? require(`../../../assets/icon/${data.iconActive}`)
                : require(`../../../assets/icon/${data.iconInactive}`)
            "
            alt="icon"
            loading="eager"
            class="w-4 h-auto"
          />
        </div>
        <div
          v-if="!minimize"
          class="transition-all duration-700 ease-in overflow-hidden"
          :class="minimize ? 'max-w-0' : 'max-w-[200px]'"
        >
          <h5 class="font-medium text-gray-800 text-sm">
            {{ data.name }}
          </h5>
          <!-- <h6 class="font-normal text-sm text-gray-800">
                        {{ data.countType }} Jenis -
                        {{ data.typeFilled + "/" + data.countType }}
                      </h6> -->
        </div>
        <div class="absolute right-0" v-if="!minimize">
          <i
            class="mdi mdi-menu-right text-4xl transition-all"
            :class="{ 'text-red-700': active || isHovered }"
          ></i>
        </div>
      </div>
    </template>
  </v-tooltip>
</template>

<script>
export default {
  name: "CardTypeConsumeComponent",
  data() {
    return {
      isHovered: false,
    };
  },
  props: {
    data: Object,
    active: Boolean,
    minimize: Boolean,
  },
  methods: {
    clickActive(type) {
      this.$emit("change-type-consume", type);
    },
  },
};
</script>
